exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-8fbf585e] .el-table{font-size:13px}[data-v-8fbf585e] .el-table .cell{line-height:14px}[data-v-8fbf585e] .el-pagination{padding:2px 0}[data-v-8fbf585e] .el-pagination .el-pagination__total{font-size:12px;margin-right:5px}[data-v-8fbf585e] .el-pagination .el-pager li{margin:0 1px;font-size:12px;min-width:25px}[data-v-8fbf585e] .el-pagination .btn-next,[data-v-8fbf585e] .el-pagination .btn-prev{margin:0 1px;min-width:25px}", ""]);

// exports
